import { render, staticRenderFns } from "./exerciseonbooks.vue?vue&type=template&id=2efbb1e6&"
import script from "./exerciseonbooks.vue?vue&type=script&lang=js&"
export * from "./exerciseonbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports